/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const RESET_ERROR = 'rewardsStore/App/RESET_ERROR';

export const SIGN_IN = 'rewardsStore/App/SIGN_IN';
export const SIGN_IN_SUCCESS = 'rewardsStore/App/SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'rewardsStore/App/SIGN_IN_ERROR';

export const RESET_PW = 'rewardsStore/App/RESET_PW';
export const RESET_PW_SUCCESS = 'rewardsStore/App/RESET_PW_SUCCESS';
export const RESET_PW_ERROR = 'rewardsStore/App/RESET_PW_ERROR';

export const SEND_MAIL = 'rewardsStore/App/SEND_MAIL';
export const SEND_MAIL_SUCCESS = 'rewardsStore/App/SEND_MAIL_SUCCESS';
export const SEND_MAIL_ERROR = 'rewardsStore/App/SEND_MAIL_ERROR';

export const LOAD_USER = 'rewardsStore/App/LOAD_USER';
export const LOAD_USER_SUCCESS = 'rewardsStore/App/LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'rewardsStore/App/LOAD_USER_ERROR';

export const LOAD_USER_IMAGE = 'rewardsStore/App/LOAD_USER_IMAGE';
export const LOAD_USER_IMAGE_SUCCESS = 'rewardsStore/App/LOAD_USER_IMAGE_SUCCESS';
export const LOAD_USER_IMAGE_ERROR = 'rewardsStore/App/LOAD_USER_IMAGE_ERROR';

export const LOAD_INITIAL_DATA = 'rewardsStore/App/LOAD_INITIAL_DATA';
export const LOAD_INITIAL_DATA_SUCCESS = 'rewardsStore/App/LOAD_INITIAL_DATA_SUCCESS';
export const LOAD_INITIAL_DATA_ERROR = 'rewardsStore/App/LOAD_INITIAL_DATA_ERROR';

export const ADD_REDEMPTION_DATA = 'rewardsStore/App/ADD_REDEMPTION_DATA';

export const SET_LOCATION = 'rewardsStore/App/SET_LOCATION';
export const TTLOGGER_EVENTLOG = 'rewardsStore/App/TTLOGGER_EVENTLOG';
export const TTLOGGER_USER_ID = 'rewardsStore/App/TTLOGGER_USER_ID';
export const TTLOGGER_SET_USER_ID = 'rewardsStore/App/TTLOGGER_SET_USER_ID';

export const ACCEPT_TOS = 'rewardsStore/App/ACCEPT_TOS';
export const ACCEPT_TOS_SUCCESS = 'rewardsStore/App/ACCEPT_TOS_SUCCESS';
export const ACCEPT_PRIVACY = 'rewardsStore/App/ACCEPT_PRIVACY';
export const ACCEPT_PRIVACY_SUCCESS = 'rewardsStore/App/ACCEPT_PRIVACY_SUCCESS';
export const LOAD_ACCEPTED_PAGES = 'rewardsStore/App/LOAD_ACCEPTED_PAGES';

export const VALIDATION_ERRORS = 'rewardsStore/App/VALIDATION_ERRORS';
export const RESET_VALIDATION_ERROR = 'rewardsStore/App/RESET_VALIDATION_ERROR';
